var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
// import { Skill } from '@/models/Portfolio';
import { Skill } from '@/models/Skill';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import LoaderCard from '@/components/loader-card/LoaderCard';
import CreateSkillDialog from '@/components/create-skill-dialog/CreateSkillDialog';
let SkillRow = class SkillRow extends Vue {
    constructor() {
        super(...arguments);
        this.isEditing = false;
        this.isLoading = true;
        this.orginalName = '';
        this.internalSkill = null;
        this.internalSkillClone = null;
        this.isShowingDeleteDialog = false;
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchSkill();
        this.isLoading = false;
    }
    cancelEditing() {
        this.isEditing = false;
        this.cloneSkill();
    }
    enableEditing() {
        this.isEditing = true;
    }
    cloneSkill() {
        this.internalSkillClone = cloneDeep(this.internalSkill);
    }
    showDeleteSkillDialog() {
        this.isShowingDeleteDialog = true;
    }
    // Asyncs
    async fetchSkill() {
        try {
            this.internalSkill = await new Skill()
                .find(this.skill.id);
            this.cloneSkill();
        }
        catch (error) {
            //
        }
    }
    async deleteSkill() {
        this.isShowingDeleteDialog = false;
        if (!this.internalSkill) {
            return;
        }
        try {
            await this.internalSkill.delete();
            this.$emit('skillDeleted');
        }
        catch (error) {
            //
        }
    }
    async updateSkill() {
        if (!this.internalSkill || !this.internalSkillClone) {
            return;
        }
        try {
            await this.internalSkill
                .update({ name: this.internalSkillClone.name });
            this.isEditing = false;
            this.$emit('onSkillUpdated');
            await this.fetchSkill();
        }
        catch (error) {
            //
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], SkillRow.prototype, "skill", void 0);
SkillRow = __decorate([
    Component({
        components: {
            LoaderCard,
            CreateSkillDialog,
        },
    })
], SkillRow);
export default SkillRow;
